export enum TenantOrganizationType {
    CreditUnion = 1,
    Bank = 2,
    Unviersity = 3,
    Other = 4
}